import { render, staticRenderFns } from "./38.vue?vue&type=template&id=1c4a953e&scoped=true&"
import script from "./38.vue?vue&type=script&lang=js&"
export * from "./38.vue?vue&type=script&lang=js&"
import style0 from "./38.vue?vue&type=style&index=0&id=1c4a953e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4a953e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c4a953e')) {
      api.createRecord('1c4a953e', component.options)
    } else {
      api.reload('1c4a953e', component.options)
    }
    module.hot.accept("./38.vue?vue&type=template&id=1c4a953e&scoped=true&", function () {
      api.rerender('1c4a953e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/product/details/38.vue"
export default component.exports